import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';

const MenuTag = ({ id, delivery, takeaway }) => {
  return (
    <styles.DescribeProducts id={id}>
      <styles.IconDelivery
        id={`${id}-delivery`}
        className={delivery ? 'active' : ''}
        active={delivery}
      />
      <styles.IconIndoor
        id={`${id}-takeaway`}
        className={takeaway ? 'active' : ''}
        active={takeaway}
      />
    </styles.DescribeProducts>
  );
};

MenuTag.propTypes = {
  id: PropTypes.string,
  delivery: PropTypes.bool,
  takeaway: PropTypes.bool,
};

export default MenuTag;



// WEBPACK FOOTER //
// ./src/components/MenuTag/index.js